module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Italic_1.da79d2cb.woff2";